import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { House, BriefcaseBusiness, School, FolderOpenDot, SquareLibrary} from "lucide-react";
import Accueil from "./pages/Accueil";
import Experiences from "./pages/Experiences";
import Projets from "./pages/Projets";
import Formations from "./pages/Formations";
import Competences from "./pages/Competences";
import NavBar from "./components/layout/NavBar";
import { Analytics } from "@vercel/analytics/react";

export default function App() {
  return (
    <Router>

      <NavBar
        logo={{
          to: "/accueil",
          root: "/",
          label: "Ulysse Gillot--Létang",
          icon: <House size={20} />
        }}
        links={[
          { path: "/experiences", label: "Expériences", icon: <BriefcaseBusiness size={20} /> },
          { path: "/projets", label: "Projets", icon: <FolderOpenDot size={20} />},
          { path: "/formations", label: "Formations", icon: <School size={20} />},
          { path: "/competences", label: "Competences", icon: <SquareLibrary size={20} />},
        ]}
      />


      <main>
        <Routes>
          <Route path="/accueil" element={<Accueil />} />
          <Route path="/experiences" element={<Experiences />} />
          <Route path="/projets" element={<Projets />} />
          <Route path="/formations" element={<Formations />} />
          <Route path="/competences" element={<Competences />} />
          <Route path="/" element={<Accueil />} />
        </Routes>
      </main>

      <footer>
        <p>© 2025 Ulysse Gillot--Létang</p>
      </footer>
      <Analytics/>
    </Router>
  );
}
